import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { MINIMUM_CELL_WIDTH, StyledMonth } from './calendar-month.styles';
export const ADDITIONAL_CALENDAR_LEFT_MARGIN = 48;
export const StyledCalendar = styled.div `
  display: flex;
  ${({ horizontal }) => css `
    flex-direction: ${horizontal ? 'row' : 'column'};

    & ${StyledMonth} + ${StyledMonth} {
      margin: ${horizontal
    ? `0 0 0 ${pxToRems(ADDITIONAL_CALENDAR_LEFT_MARGIN)}`
    : `${pxToRems(32)} 0 0 0`};
    }
  `}
`;
export const StyledContainer = styled.div `
  position: relative;
  ${({ horizontal, monthsToShow }) => css `
    padding-top: ${horizontal ? 0 : pxToRems(24)};
    min-width: ${pxToRems(MINIMUM_CELL_WIDTH * 7 * (horizontal ? monthsToShow : 1) +
    (horizontal ? (monthsToShow - 1) * ADDITIONAL_CALENDAR_LEFT_MARGIN : 0))};
    max-width: ${horizontal && monthsToShow >= 2 ? 'none' : pxToRems(720)};
  `}
`;
export const StyledNoAvailability = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.ColorWhiteOpacity90};
`;
//# sourceMappingURL=calendar.styles.js.map